import { render, staticRenderFns } from "./Productviewer.vue?vue&type=template&id=afe7b31c&scoped=true"
import script from "./Productviewer.vue?vue&type=script&lang=js"
export * from "./Productviewer.vue?vue&type=script&lang=js"
import style0 from "./Productviewer.vue?vue&type=style&index=0&id=afe7b31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe7b31c",
  null
  
)

export default component.exports